import { getTechnologyFilter, isTechnologyRequired, TechnologyDropdown } from 'domain/shared/career';
import { PositionDropdown } from 'domain/shared/employee';
import { EnumDropdown, DefaultInputPropTypes, useFormContext, useInputHelper } from 'framework/form';
import { ErrorMessage, useMessageService } from 'framework/ui/Message';
import { Grid2 as Grid } from '@mui/material';
import { getLastSource } from 'framework/utils';
import { DUPLICATE_SECONDARY_COMPETENCY_MESSAGE, isDuplicateSecondaryCompetency } from '../positionSlotValidation';
import { SECONDARY_COMPETENCY_LEVEL_OPTIONS } from '../../constants';

const SecondaryCompetencyRowInput = (props: DefaultInputPropTypes<any> & { index?: number }) => {
  const { getSource, getRawOnChangeCallback, getValue, getIsDisabled } = useInputHelper(props);
  const { data } = useFormContext();
  const { addMessage } = useMessageService();
  const row = getValue() || {};
  const rawOnChangeCallback = getRawOnChangeCallback() || (() => {});
  const source = getSource();
  const disabled = Boolean(getIsDisabled());
  const specializationId = row.specializationId as string | number | undefined;

  const onChangeCallback = (value: { [x: string]: any }) => {
    const changed = getLastSource(value);
    // Technology belongs to the previously selected specialization, so it is dropped on change.
    const technologyReset = 'specializationId' in changed ? { technologyId: null } : {};
    const next = { ...row, ...technologyReset, ...changed };
    if (
      isDuplicateSecondaryCompetency(data as any, (data?.secondaryCompetencies as any[]) ?? [], props.index ?? -1, next)
    ) {
      addMessage(new ErrorMessage(DUPLICATE_SECONDARY_COMPETENCY_MESSAGE));
      return;
    }
    rawOnChangeCallback({ [source]: next });
  };

  return (
    <Grid container spacing={2} sx={{ flexGrow: 1 }}>
      <Grid size={{ xs: 12, md: 4, xl: 4 }}>
        <PositionDropdown
          source={`${source}.specializationId`}
          value={row.specializationId}
          label="Specialization"
          isRequired
          disabled={disabled}
          onChangeCallback={onChangeCallback}
        />
      </Grid>
      {isTechnologyRequired(specializationId) && (
        <Grid size={{ xs: 12, md: 4, xl: 4 }}>
          <TechnologyDropdown
            source={`${source}.technologyId`}
            value={row.technologyId}
            label="Technology"
            isRequired
            customReduce={getTechnologyFilter(specializationId)}
            deps={[specializationId]}
            disabled={disabled}
            onChangeCallback={onChangeCallback}
          />
        </Grid>
      )}
      <Grid size={{ xs: 12, md: 4, xl: 4 }}>
        <EnumDropdown
          source={`${source}.competencyLevel`}
          value={row.competencyLevel}
          label="Level"
          options={SECONDARY_COMPETENCY_LEVEL_OPTIONS}
          isRequired
          disabled={disabled}
          onChangeCallback={onChangeCallback}
        />
      </Grid>
    </Grid>
  );
};

export default SecondaryCompetencyRowInput;
